import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface CxoneOrderManagementGridTextContainerInterface {
    text?: string,
    customStyle?: string,
}

@Component({
  selector: 'cv-cxone-order-management-grid-text-container',
  templateUrl: './cxone-order-management-grid-text-container.component.html',
  styleUrl: './cxone-order-management-grid-text-container.component.scss'
})
export class CxoneOrderManagementGridTextContainerComponent implements ICellRendererAngularComp {
    text?: string;
    customStyle?: string;
    constructor() {}
    agInit(params: ICellRendererParams<any, any, any> & CxoneOrderManagementGridTextContainerInterface): void {
        this.text = params.text;
        this.customStyle = params.customStyle;
    }
    
    refresh(params: ICellRendererParams<any, any, any>): boolean {
        return false;
    }

    isTextHasEllipsis(element: HTMLElement): boolean {
        return element.scrollWidth > element.clientWidth;
    }
}
